import createFastContext from "../createFastContext";

export const { Provider: ImageSearchProvider, useStore: imageSearchUseStore } =
  createFastContext({ cases: [] });
